import { render, staticRenderFns } from "./BankAndFreeSessionsReportTable.vue?vue&type=template&id=2cc8c512&scoped=true"
import script from "./BankAndFreeSessionsReportTable.vue?vue&type=script&lang=ts"
export * from "./BankAndFreeSessionsReportTable.vue?vue&type=script&lang=ts"
import style0 from "./BankAndFreeSessionsReportTable.vue?vue&type=style&index=0&id=2cc8c512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8c512",
  null
  
)

export default component.exports